"use strict";
(function () {
  const $ = require('jQuery');
  const helpers = require('../helpers');
  const icons = require('../icons');
  const toastr = require('toastr');
  const ace = require('ace-builds');
  const tooltips = require('./machinelogic_tooltips');

  let gContextMenu;
  let gCounter = 0;
  const _getId = function () {
    gCounter++;
    return gCounter;
  };
  const gIdGenerator = function () {
    let _lAppCount = 0;
    let _lSeqCount = 0;
    let _lInstCount = 0;

    function IdGenerator() {
      this.nextAppId = function () { _lAppCount += 1; return 'application_' + _lAppCount; };
      this.nextSequenceId = function () { _lSeqCount += 1; return 'sequence_' + _lSeqCount; };
      this.nextInstructionId = function () { _lInstCount += 1; return 'instruction_' + _lInstCount; };
    }
    return new IdGenerator();
  }();

  require('ace-builds/src-noconflict/theme-cloud9_day');
  require('ace-builds/src-noconflict/mode-javascript');

  function messageBox(pMessage, pLevel, pOptions = {}) {
    if (undefined != toastr) {
      if(undefined == toastr.options || Object.keys(toastr.options).length == 0) {
        toastr.options = {
          "closeButton": true,
          "positionClass": "toast-top-center",
          "preventDuplicates" : true,
        };
      }

      toastr.options = { ...toastr.options, ...pOptions };

      switch (pLevel) {
        case undefined:
        case 'info': toastr.info(pMessage, undefined, pOptions); break;
        case 'warning': toastr.warning(pMessage, undefined, pOptions); break;
        case 'error': toastr.error(pMessage, undefined, pOptions); break;
        case 'success': toastr.success(pMessage, undefined, pOptions); break;
      }
    } else {
      alert(pMessage + (undefined != pLevel ? (' [' + pLevel + ']') : ''));
    }
  }

  function clearMessageBox() {
    if (undefined != toastr) {
      toastr.clear();
    }
  }

  /**
  * An autocomplete field
  * @param {string} pName - Used as id
  * @param {string} pTooltip - Should as tooltip when hovered
  * @param {number} pValue
  * @param {string} pUnits - Unit to represent the value
  * @param {{ min: number, max: number, step: number }} pOptions - Options are used to set the limits and step
  * @param {function} pOnValue - value triggered when change value. This callback has nodeJS style callback(err, data)
  * @deprecated - this widget has been replaced by the autocompleteComponent in vse_ui/base_components/base_components.js
  */
  function autocompleteWidget(pName, pTooltip, pUnits, pOptions, pInitialSource, pValidationFunctions, pValue, pOnValue) {
    console.warn('The autocomplete widget is deprecated and no longer supported, using it might lead to unintend behaviour');
    const _lDiv = pName ? baseWidget(pName) : null;
    const _lAutoCompleteOptions = pInitialSource;
    const _lWidget = $('<input type="text" class="ml_input_clean" title="' + pTooltip + '"/>').autocomplete({
      source: function( request, response ) {
        if ( getVariableAt(lCache, lCursorPos).variable.length == 0) { response([]); }
        else { response( $.ui.autocomplete.filter( _lAutoCompleteOptions, getVariableAt(lCache, lCursorPos).variable ) ); }
      },
      focus: function() {
        // prevent value inserted on focus
        return false;
      },
    });
    const _lError = $('<span class="ml_input_validation_error"> </span>');
    let _lUnits;
    let _lValidation;
    let _lLastValue;
    const lAdditionalDisplayDiv = $('<div>');
    const lConfigListenerMapping = {};

    _lWidget.autocomplete('instance')._renderMenu = function (ul, items) {
      const lThis = this;
      ul.addClass('ml_autocomplete_menu', 'margin: 0; padding: 8px 0px; overflow: auto; list-style: none; max-height: 40vh;');
      $.each(items, function (index, item) {
        lThis._renderItemData(ul, item);
      });
    };
    _lWidget.autocomplete('instance')._renderItem = function (ul, item) {
      return $("<li>")
        .addClass('ml_autocomplete_items')
        .attr("data-value", item.value)
        .append(item.label)
        .appendTo(ul);
    };

    function updateTooltip(pWidget, pParameterValue) {
      if (pOptions && pOptions.hasOwnProperty('pApp')) {
        let lMessage = pTooltip + '(value = ' + pOptions.pApp.getParametersObject().listParametersName() + ')';
        if (pOptions.pApp.getParametersObject().listParametersName().includes(pParameterValue)) {
          lMessage = pTooltip + '(Initial value = ' + pOptions.pApp.getParametersObject().getParameterValue(pParameterValue) + ')';
          pWidget.attr('title', lMessage);
        } else {
          lMessage = pTooltip;
          pWidget.attr('title', lMessage);
        }
      }
    }


    if (pValidationFunctions) {
      _lValidation = helpers.validateForm(pValidationFunctions);
    }

    if (pUnits) {
      // Dynamic units
      if (pUnits.includes("configDependant")) {
        const _determineConfigDependantUnit = function () {
          let _lUnit = pOptions.configManager._getConfigDependant_Unit();
          if (pUnits.includes("Velocity")) {
            _lUnit = _lUnit + "/s";
          }
          else if (pUnits.includes("Acceleration")) {
            _lUnit = _lUnit + "/s^2";
          }
          return _lUnit;
        };
        _lWidget.css('width', 'calc(100% - 35px)');
        _lUnits = $('<div class="ml_parameter_unit">' + _determineConfigDependantUnit().replace(/\^([0-9]+)/g, '<sup>$1</sup>') + '</div>');
        // React to config changes
        const _updateConfigDependantUnit = function () {
          _lDiv.find('.ml_parameter_unit').html(_determineConfigDependantUnit().replace(/\^([0-9]+)/g, '<sup>$1</sup>'));
        };

        pOptions.configManager.getConfigurationList().forEach(function(pConfig) {
          const lConfigListener = {
            onAxisAdded: _updateConfigDependantUnit,
            onAxisRemoved: _updateConfigDependantUnit,
            onAxisTypeChanged: _updateConfigDependantUnit
          };

          pConfig.addListener(lConfigListener);
          lConfigListenerMapping[pConfig.getController().getUUID()] = lConfigListener;
        });
      }
      // Static units
      else {
        (pUnits == "mm" || pUnits == "deg") ? _lWidget.css('width', 'calc(100% - 35px)') : _lWidget.css('width', 'calc(100% - 57.5px)');
        _lUnits = $('<div class="ml_parameter_unit">' + pUnits.replace(/\^([0-9]+)/g, '<sup>$1</sup>') + '</div>');
      }
    }

    if (pOptions && pOptions.hasOwnProperty('pApp')) {
      // Update initial value on loading
      updateTooltip(_lWidget, pValue);

    }

    _lWidget.val(pValue);

    if (pOptions) {
      Object.keys(pOptions).forEach(function (pOption) {
        _lWidget.attr(pOptions, pOptions[pOption]);
      });
    }

    function isNotValidValue(pValue) {
      if (_lValidation) {
        const lValue = pValue;
        const lCheckError = _lValidation(lValue);
        const lError = new Error(lCheckError);
        if (lCheckError) {
          if (pOnValue) {
            setValue(_lLastValue);
            pOnValue(lError);
          }
          return lError;
        }
      }
    }

    // change event
    _lWidget.on('autocompletechange', function (pEvent) {
      pEvent.stopPropagation();
      const lValue = _lWidget.val();
      const lValidationError = isNotValidValue(lValue);
      if (lValidationError) {
        updateAdditionalDisplay(_lLastValue);
        return;
      }
      if (pOnValue) {
        _lLastValue = lValue;
        pOnValue(null, lValue);
        updateTooltip(_lWidget, lValue);
      }
    });

    let lCache = _lWidget.val();
    let lCursorPos = 0;

    function getVariableAt (str, pos) {
      // Search for the word's beginning and end.
      let lLeftPos;
      const lRegex = /[\+\-\,\*\/]/g;
      const lMatches = [...str.slice(0, pos + 1).matchAll(lRegex)];
      if (lMatches.length == 0) { lLeftPos = 0; }
      else { lLeftPos = lMatches[lMatches.length - 1].index + 1; }
      const lRightPos = str.slice(pos).search(lRegex);

      // The slast word in the string is a special case.
      if (lRightPos < 0) {
        return {variable: str.slice(lLeftPos).trim(), left: lLeftPos, right: lRightPos};
      }
      // Return the word, using the located bounds to extract it from the string.
      return {variable: str.slice(lLeftPos, lRightPos + pos).trim(), left: lLeftPos, right: lRightPos};
    }

    _lWidget.keyup(function(e){
      lCache = $(this).val();
      lCursorPos = e.target.selectionStart;
    });

    // select event
    _lWidget.on('autocompleteselect', function (pEvent, pUI) {
      pEvent.stopPropagation();

      const lVariableAtPos = getVariableAt(lCache, lCursorPos);
      if (lCursorPos == lCache.length) {
        if (lVariableAtPos.variable.length != 0) { lCache = lCache.slice(0, -1 * lVariableAtPos.variable.length); }
        lCache = lCache + pUI.item.value;
      }
      else {
        lCache = `${lCache.slice(0, lVariableAtPos.left)} ${pUI.item.value} ${lCache.slice(lVariableAtPos.right + lCursorPos)}`;
      }
      setValue(lCache);
      return false;
    });

    function setValue(lValue) {
      _lWidget.val(lValue);
    }

    /**
     *
     * @param {jQuery} pIcon - A jQuery icon representing an icon
     */
    function setLabelIcon(pIcon) {
      if (!_lDiv) { return; }
      pIcon.addClass('ml_label_icon');
      const _lExistingIcon = _lDiv.find('.ml_label_icon');
      if (_lExistingIcon.length) {
        _lExistingIcon.replaceWith(pIcon);
      } else {
        _lDiv.find('.h_layout:not(.ml_parameter_widget)').append(pIcon);
      }
    }

    function detachLabelIcon() {
      if (!_lDiv) { return; }
      const _lExistingIcon = _lDiv.find('.ml_label_icon');
      if (_lExistingIcon.length) {
        _lExistingIcon.detach();
      }
    }

    function onRemoveCallback() {
      if (pUnits && pUnits.includes("configDependant")) {
        Object.keys(lConfigListenerMapping).forEach(function(pControllerId) {
          const lConfig = pOptions.configManager.getConfiguration(pControllerId);
          if (lConfig) {
            lConfig.removeListener(lConfigListenerMapping[pControllerId]);
          }
        });
      }
    }

    function updateAdditionalDisplay(pValue) {
      lAdditionalDisplayDiv.empty();
      if(!pOptions) { return; }
      const { additionalDisplay, configManager } = pOptions;
      if(!additionalDisplay || !configManager) { return; }

      const {_lMmPresence, _lDegPresence} = configManager._getConfigDependant_DegAndMMPresence(); // if there is no presence of "deg" in any of the axes, do not show the addition unit info
      if(!(_lMmPresence && _lDegPresence)) { return; }

      const { before, value, after } = additionalDisplay;
      const additionalUnitDisplay = innerUnitDisplay(before, pValue ? pValue : value, after);

      lAdditionalDisplayDiv.css({ 'align-self': 'flex-end', 'font-size': '0.9rem', 'line-height': '1rem', padding: '0 0.25rem', marginTop: '-10px' });
      lAdditionalDisplayDiv.find('span').css({ padding: '0 0.25rem' });
      lAdditionalDisplayDiv.append(additionalUnitDisplay);
    }

    _lWidget.on('input', (e) => {
      const lValue = e.currentTarget.value;
      updateAdditionalDisplay(lValue);
    });

    // Initialize cached value
    _lLastValue = _lWidget.val();

    if (_lDiv) {
      _lDiv.append($('<div class="ml_parameter_widget h_layout spaced"/>').append(_lWidget).append(_lUnits));
      _lDiv.append(lAdditionalDisplayDiv);
      updateAdditionalDisplay();

      _lDiv.append(_lError);
      _lDiv.setValue = setValue;
      _lDiv.setLabelIcon = setLabelIcon;
      _lDiv.detachLabelIcon = detachLabelIcon;

      _lDiv.on('remove', onRemoveCallback);

      return _lDiv;
    } else {
      _lWidget.addClass('ml_parameter_widget');
      _lWidget.setValue = setValue;

      _lWidget.on('remove', onRemoveCallback);

      return _lWidget;
    }
  }

  /**
   * @typedef {Object} BaseWidgetOptions
   * @prop {boolean} [showInstructionNumber] applies styling specific to adding the instruction widget number to a card. Removes the ml_icon class
   * @prop {boolean} [isForIcon] passed by the card component too add the required css class
   * @prop {string} [tooltipKey] key to use to get the tooltip text
   *
   * @param {string} pName name
   * @param {(string) => string} [pTextTransformFunc] function to use to transform the name. If none is passed, camelCaseToText is used
   * @param {BaseWidgetOptions} [pOptions] {showInstructionNumber, isForIcon}
   * @returns {JQuery<HTMLElement>}
   */
  function baseWidget(pName, pTextTransformFunc, { showInstructionNumber = false, isForIcon = false, tooltipKey = undefined } = {}) {
    const lContainer = $('<div>').addClass('ml_parameter');
    const lErrorIcon = $('<div>').addClass('ml_error_icon').append(icons.error);
    const lWidgetLabel = $('<h5>');

    if (!pTextTransformFunc) {
      pTextTransformFunc = camelCaseToText;
    }
    if (typeof pName == 'string') {
      lContainer.append(
        $('<div class="h_layout"/>').append(
          lErrorIcon,
          lWidgetLabel.append(pTextTransformFunc(pName)).addClass(`ml_widget_label`)
        )
      );

      if(isForIcon) {
        lContainer.addClass('ml_icon v_layout spaced');
      }

      if(showInstructionNumber) {
        lContainer.removeClass('ml_icon');
        lWidgetLabel.addClass('ml_number');
      }

      if(tooltipKey) {
        lWidgetLabel.append(
          $('<span>').addClass(`ml_tooltip_icon ml_label_icon ${icons.unknown}`).on( 'click', function () { tooltips.showTips(tooltipKey); })
        );
      }
    }

    return lContainer;
  }

  // Note: this can be done with css `text-transform: capitalize;`
  function camelCaseToText(pString) {
    return pString.toString().replace(/([A-Z])/g, ' $1').replace(/^./, function (str) { return str.toUpperCase(); });
  }

  /**
   * @param {Object} pTitle - title object
   * @param {string} pTitle.text
   * @param {Object} [pTitle.style]
   * @param {Object} pSubTitle - subtitle object
   * @param {string} pSubTitle.text
   * @param {Object} [pSubTitle.style]
   * @param {Object} pConfirmButton - confirm button object
   * @param {string} [pConfirmButton.id]
   * @param {string} pConfirmButton.text
   * @param {Object} [pConfirmButton.style]
   * @param {(event: Event) => void} pConfirmButton.onClick
   * @param {Object} pCancelButton - cancel button object
   * @param {string} [pCancelButton.id]
   * @param {string} pCancelButton.text
   * @param {Object} [pCancelButton.style]
   * @param {(event: Event) => void} [pCancelButton.onClick]
   */
  function showConfirmCancelModal(pTitle, pSubTitle, pConfirmButton, pCancelButton) {
    const lModalContainer = $('<div>', { class: 'ml_modal_container' }).appendTo('body');
    const lModal = $('<div>', { class: 'ml_modal ml_validator_confirmation_modal' }).appendTo(lModalContainer);
    const lHeader = $('<div>').appendTo(lModal);
    const lFooter = $('<div>').appendTo(lModal);
    $('<div>').attr('id', () => pTitle.id).css(pTitle.style ? pTitle.style : {} ).text(pTitle.text).appendTo(lHeader);
    $('<div>').attr('id', () => pSubTitle.id).css(pSubTitle.style ? pSubTitle.style : {} ).text(pSubTitle.text).appendTo(lHeader);
    $('<div>').text('x').appendTo(lHeader).click(() => { pCancelButton.onClick?.(); lModalContainer.remove(); });
    $('<button>').attr('id', () => pCancelButton.id).css(pCancelButton.style).text(pCancelButton.text).appendTo(lFooter).click(() => { pCancelButton.onClick?.(); lModalContainer.remove(); });
    $('<button>').attr('id', () => pConfirmButton.id).css(pConfirmButton.style).text(pConfirmButton.text).appendTo(lFooter).click(() => { pConfirmButton.onClick?.(); lModalContainer.remove(); }).focus();
  }

  function showConfirmationModal(pTitle, pSubTitle, pOnConfirm, pOnCancel) {
    showConfirmCancelModal(
      { text: pTitle },
      { text: pSubTitle },
      { text: `Yes, ${pTitle}`, id: 'EH_change_act', style: {}, onClick: pOnConfirm },
      { text: 'Cancel', style: {}, onClick: pOnCancel },
    );
  }

  function loadingModal(pTitle, pLoading, pCanCancel, pOnCancel) {
    const lModalContainer = $('<div>', { class: 'ml_modal_container' }).appendTo('body');
    const lModal = $('<div>', { class: 'ml_modal ml_validator_confirmation_modal' }).appendTo(lModalContainer);
    const lHeader = $('<div>').appendTo(lModal);
    // TODO: the keyframes for the animation is defined on dist/vse.css
    // the current jQuery version in the pendant is 2.1.4
    const spinner = $('<div>', { class: 'ml_spinner' }).css({
      display: 'inline - block',
      width: '50px',
      height: '50px',
      border: '3px solid rgba(45, 58,77,.3)',
      'border-radius': '50%',
      'border-top-color': 'rgb(45, 58, 77)',
      animation: 'spin 1s ease-in-out infinite',
      '-webkit-animation': 'spin 1s ease -in -out infinite',
    });
    const loadingElement = pLoading || spinner;

    // Title
    $('<div>').text(pTitle).appendTo(lHeader);
    // SubTitle
    $('<div>').appendTo(lHeader);
    pCanCancel ? $('<div>').text('x').appendTo(lHeader).click(() => { if (pOnCancel) { pOnCancel(); } lModalContainer.remove(); }) : $('<div>').appendTo(lHeader);
    loadingElement && loadingElement.appendTo(lHeader);
    return lModalContainer;
  }

  // Basic frame with icon, parameters and close button
  function card(pIcon, pOnClose, lConfirmationObject, { hideParameters = false, showInstructionNumber = false } = {}) {
    const _lCardWidget = $('<div class="ml_card h_layout spaced bordered">'); let _lBlockOnClose = null;
    _lCardWidget.icon =
      baseWidget('', false, {isForIcon: true, showInstructionNumber: showInstructionNumber})
        .append(
          pIcon ?
            $('<div class="' + pIcon + '">') :
            [$('<div class="green_circle">'), $('<div class="orange_circle">'), $('<div class="red_circle">')]
        );
    _lCardWidget.parameters = $('<div class="ml_parameters g_layout spaced">');
    _lCardWidget.close = $('<button class="ml_close ml_close_card_widget"/>');

    // Note (alevy): this is hard coded because
    // the output/input icons have a different sizes
    if (pIcon && pIcon.match(/icon-arrow/i)) {
      _lCardWidget.icon.css({ 'font-size': '0.8rem' });
    }

    if (pOnClose) {
      _lCardWidget.close.click(function () {
        if (!_lBlockOnClose) {
          if (!lConfirmationObject || lConfirmationObject.getMessage() == null) {
            pOnClose();
            _lCardWidget.remove();
          }
          else {
            showConfirmationModal(
              lConfirmationObject.title,
              lConfirmationObject.getMessage(),
              function() {
                pOnClose();
                _lCardWidget.remove();
              }
            );
          }
        }
      });
    }

    _lCardWidget.blockOnClose = function () {
      _lBlockOnClose = true;
    };
    _lCardWidget.unBlockOnClose = function () {
      _lBlockOnClose = null;
    };
    // Note (alevy): Added to handle actuator first
    // we have a mix of categories to the all axes option
    // when showing actuator first
    // mm-vention-control#862
    function updateIcon(_pIcon) {
      const lIconDiv = _lCardWidget.icon.children().last();
      lIconDiv.removeClass();
      lIconDiv.addClass(_pIcon);
    }

    function addAxisButton(_pAddAxisWidget) {
      _lCardWidget.addAxis = _pAddAxisWidget;
      _lCardWidget.append(_pAddAxisWidget);
      _lCardWidget.addAxis.hide();
    }

    function hasAddAxis() {
      return !!_lCardWidget.addAxis;
    }

    function showAxisButton() {
      if (_lCardWidget.addAxis) {
        _lCardWidget.addAxis.show();
      }
    }

    function hideAxisButton() {
      if (_lCardWidget.addAxis) {
        _lCardWidget.addAxis.hide();
      }
    }

    _lCardWidget.updateIcon = updateIcon;
    _lCardWidget.hasAddAxis = hasAddAxis;
    _lCardWidget.addAxisButton = addAxisButton;
    _lCardWidget.showAxisButton = showAxisButton;
    _lCardWidget.hideAxisButton = hideAxisButton;

    _lCardWidget.append(
      _lCardWidget.icon,
      hideParameters ? '' : _lCardWidget.parameters,
      _lCardWidget.close);


    return _lCardWidget;
  }

  /* Downloads any object as a JSON file */
  function downloadJson(pFilename, pContent) {
    // Temporary <a> tag that clicks automatically and removes itself
    $("<a />", {
      "download": pFilename,
      "href" : "data:application/json," + encodeURIComponent(pContent)
    }).appendTo("body")
      .click(function() {
        $(this).remove();
      })[0].click();
  }

  /* Contextual menu */
  function contextMenu(pOnClose) {
    const lOnClick = function (_pEvent) {
      const _lO = gContextMenu.offset();
      const _lW = gContextMenu.outerWidth(true);
      const _lH = gContextMenu.outerHeight(true);

      if (_pEvent.pageX < _lO.left || _pEvent.pageX > (_lO.left + _lW) ||
            _pEvent.pageY < _lO.top  || _pEvent.pageY > (_lO.top + _lH)) {
        lHide();
      }
      return true;
    };
    const lOnKey = function (_pEvent) {
      if (_pEvent.keyCode === 27) {
        lHide();
        return false;
      }
      return true;
    };
    const lHide = function () {
      gContextMenu && gContextMenu.remove();
      gContextMenu = undefined;
      $(window).off("keydown", lOnKey);
      $(document).off("click", lOnClick);
      if (undefined != pOnClose) { pOnClose(); }
    };


    // Clear any existing menu and create a new one
    if(gContextMenu) {
      gContextMenu.hide();
    }
    gContextMenu = $('<div class="ml_context_menu"/>').appendTo($('body'));

    gContextMenu.on('contextmenu', function() { return false; }); // Workaround for a strange issue near the edges, whereby the browser menu appears on top of ours, not sure exactly due to what chain of events...

    gContextMenu.addItem = function (pText, pCallback, pProps) {
      const _lMenuItem = $('<div class="ml_context_menu_item ml_ui_builder_context_menu_item"/>').appendTo(gContextMenu);

      const lDisabledOption = pProps && pProps.disabled;
      if(lDisabledOption) {
        _lMenuItem.attr('disabled', true);
        _lMenuItem.css({ 'color': '#A0A0A0'});
      }

      if (undefined != pText) {
        if (typeof pText === 'string' && pText.length > 0) {
          _lMenuItem.text(pText);
        }
        else {
          if(lDisabledOption) { pText.css({ 'color': '#A0A0A0'}); }
          _lMenuItem.append(pText);
        }

        if(!lDisabledOption) { _lMenuItem.click(function (_pEvent) { if (pCallback) { pCallback(_pEvent); } lHide(); }); }
      }
      return _lMenuItem;
    };

    const lBaseHide = gContextMenu.hide;
    gContextMenu.hide = function() {
      lBaseHide.call(gContextMenu);
      lHide();
    };

    const lBaseShow = gContextMenu.show;
    gContextMenu.show = function (pX, pY) {
      $(document).on('click', lOnClick);
      $(window).on('keydown', lOnKey);

      // Always keep floating menus inside the screen boundaries...
      pX += Math.min($(window).width() - (pX + gContextMenu.outerWidth(true)), 0);
      pY += Math.min($(window).height() - (pY + gContextMenu.outerHeight(true)), 0);

      const parentZindex = isNaN(gContextMenu.parent().css('z-index')) ? 0 : gContextMenu.parent().css('z-index');
      const previousSiblingZindex = isNaN(gContextMenu.prev().css('z-index')) ? 0 : gContextMenu.prev().css('z-index');
      const maxZIndex = Math.max(parentZindex, previousSiblingZindex);
      gContextMenu.css({ left: pX + 'px', top: pY + 'px', 'z-index': maxZIndex + 1 });
      lBaseShow.call(gContextMenu);
    };

    return gContextMenu;
  }


  function checkbox(pID, pChecked, pOnCheck, pShape) {
    const lInputId = `${pID}_input_${_getId()}`;
    const lLabelForId = pID ? `for="${lInputId}"` : '';

    const container = $(`<label ${lLabelForId}>`)
      .addClass('ml_checkbox')
      .attr('id', (pID ? pID + '_' : '') + _getId());

    const lCheckbox = $('<input type="checkbox">')
      .attr('id', pID ? lInputId : null)
      .prop('checked', pChecked);

    const lCheckboxUI = $('<span>').addClass('ml_checkmark');

    pShape === 'circle' ? lCheckboxUI.addClass('ml_checkmark_circle') :  lCheckboxUI.addClass('ml_checkmark_square');

    container.append(lCheckbox, lCheckboxUI);

    const updateStyles = function() {
      if(lCheckbox.is(':checked')) { lCheckboxUI.addClass('fal fa-check'); }
      else { lCheckboxUI.removeClass('fal fa-check'); }
    };

    updateStyles();

    lCheckbox.change(function() { updateStyles(); if(pOnCheck) { pOnCheck(lCheckbox.is(':checked')); } });
    container.on('set_checked',  function(pEvent, pChecked)  { lCheckbox.prop('checked', pChecked);   updateStyles(); });
    container.on('set_disabled', function(pEvent, pDisabled) { lCheckbox.prop('disabled', pDisabled); updateStyles(); });

    return container;
  }

  /**
   * Widget that layouts a checkbox and a label text on the side
   * @param {!string} pName Text to show on the side of the checkbox
   * @param {!boolean} pChecked Initial value for checkbox
   * @param {Function} pOnCheck Callback function called when click on the checkbox
   * @param {string} pShape To show either square checkbox or circle
   */
  function checkBoxParameter(pName, pChecked, pOnCheck, pShape) {
    const lDiv = $('<div class="v_layout justify-center"></div>').css({});
    const lCheckbox = checkbox(pName, pChecked, pOnCheck, pShape);
    const lCheckboxWrapper = $('<div class="h_layout justify-center"></div>').css({ 'margin-top': '1rem'});
    const lText = $('<h5 class="ml_widget_label">' + camelCaseToText(pName) + '</h5>').css({ 'font-size': '14px', 'font-weight': '400', 'padding-left': '0.25rem' });

    lCheckboxWrapper.append(lCheckbox, lText);
    lDiv.append(lCheckboxWrapper);
    return lDiv;
  }

  function button(pID, pIcon, pTooltip) {
    const _lButton = $('<button class="ml_button"/>').attr('id', pID);
    let _lIcon = null;
    const _setIcon = function(pIcon) { _lButton.removeClass(_lIcon); _lIcon = pIcon; _lButton.addClass(pIcon); };
    const _setTooltip = function(pTooltip) { _lButton.attr('title', pTooltip); };

    _setIcon(pIcon);
    _setTooltip(pTooltip);

    _lButton.on('icon_changed', function(pEvent, pIcon) { _setIcon(pIcon); } );
    _lButton.on('tooltip_changed', function(pEvent, pTooltip) { _setTooltip(pTooltip); } );
    _lButton.on('click', function(pEvent) {
      // Disable space/enter keys from clicking focused button
      if(pEvent.originalEvent && pEvent.originalEvent.detail == 0) {
        pEvent.stopImmediatePropagation();
      }
    });

    return _lButton;
  }

  function textButton(pID, pText, pTooltip, pOnClick) {
    const _lTextButton = $('<button type="button"' + (pID ? ' id="' + pID +  '"' : '') + ' class="ml_button_text"' + (pTooltip ? ' title="' + pTooltip + '"' : '') + '>' + pText + '</button>');

    if(pOnClick) { _lTextButton.click(pOnClick); }

    return _lTextButton;
  }

  function pushButton(pID, pIcon, pTooltip, pOnClick) {
    const _lPushButton = button(pID, pIcon, pTooltip);

    if(pOnClick) { _lPushButton.click(pOnClick); }

    return _lPushButton;
  }

  /**
   * Layout for pneumatic push/pull commands
   * @param {Object} pParams - UI props for pneumatic commands
   * @param {String} pParams.commandTitle - Push/Pull command
   * @param {String} pParams.valveTitle - Title for valve command
   * @param {String} pParams.valveTooltip - Tooltip to show on hovering the valve element
   * @param {Array} pParams.valveValuesList - List of options to show on the dropdown
   * @param {String/Number} pParams.valveInitialValue - Valve initial value
   * @param {Function} pParams.valveOnValue - Callback on change the value
   * @param {String} pParams.switchTitle - Switch dropdown title
   * @param {Array} pParams.switchValuesList - List of options to show on the dropdown
   * @param {String} pParams.switchTooltip - Tooltip to show on hovering the switch element
   * @param {String/Number} pParams.switchInitialValue - Tooltip to show on hovering the switch element
   * @param {Function} pParams.switchOnValue - Callback on change the value
   *
   */
  function pneumaticCommands(pParams) {
    const {
      commandTitle,
      valveTitle,
      valveValuesList,
      valveTooltip,
      valveInitialValue,
      valveOnValue,
      switchTitle,
      switchTooltip,
      switchInitialValue,
      switchOnValue,
      switchValuesList,
    } = pParams;
    const lContainer = baseWidget(commandTitle);
    const lValve = listWidget(valveTitle, valveValuesList, valveTooltip, valveInitialValue, valveOnValue);
    const lReedSwitch = listWidget(switchTitle, switchValuesList, switchTooltip, switchInitialValue, switchOnValue);
    const lCommandContainer = $('<div class="ml_pneumatic_command_grid"> </div>');

    lValve.css({ 'justify-content': 'flex-end' });
    lContainer.addClass('v_layout');
    lCommandContainer.append(lValve, lReedSwitch);
    lContainer.append(lCommandContainer);

    lContainer.getValve = function() { return lValve; };
    lContainer.getSwitch = function() { return lReedSwitch; };

    function updateLabel(pLabel) {
      if (!lContainer) return;
      lContainer.find('.ml_widget_label').first().text(pLabel);
    }

    lContainer.updateLabel = updateLabel;
    return lContainer;
  }

  /**
   *
   * @param {String} pID
   * @param {String} pText
   * @param {Boolean} pBreakline
   * @param {String} pIconClass
   * @param {String} pTooltip
   * @param {Function} pOnClick
   * @param {Boolean} pDisabled
   */
  function textIconButton(pID, pText, pBreakline, pIconClass, pTooltip, pOnClick, pDisabled) {
    const lButton = $('<button class="ml_button_text_icon" title="' + pTooltip + '"> </button>');
    const lIcon = $('<i class="' + pIconClass + ' ml_button_icon"> </i>');
    const lFormattedText = pBreakline ? pText.split(' ').join('<br/>') : pText;
    const lText = $('<div class="ml_button_text_cta">' + lFormattedText + '</div>');

    if (pDisabled) {
      lButton.attr('disabled', 'disabled');
    }

    pID && lButton.attr('id', pID);
    lButton.append(lIcon, lText);
    pOnClick && lButton.click(pOnClick);
    return lButton;
  }

  function dropDownWidget(pName, pStyleMap, pValue, pOnValue) {
    const _lDiv = pName ? baseWidget(pName) : null;
    let _lSelected = $('<p class="ml_dropdown_list_selected">' + pStyleMap[pValue]["text"] + '</p>').css(pStyleMap[pValue]["css"]);
    const _ldropDownIcon = $('<div class="ml_dropdown_list_icon ' + icons.chevronDown + ' "/>');
    const _lWidgetDiv = $('<div class="ml_dropdown_list_button" ></div>').on('click', function() {lToggle();}).append([_lSelected, _ldropDownIcon]);
    const _lWidgetContent = $('<div class="ml_dropdown_context">');
    let lIsVisible = false;
    Object.keys(pStyleMap).forEach(function(lListEle){
      const _listElement = $('<div class="ml_dropdown_list_item">' + pStyleMap[lListEle]["text"] + '</div>').css(pStyleMap[lListEle]["css"])
        .on('click', function(){
          _lSelected.remove();
          _ldropDownIcon.remove();
          _lSelected = $('<p class="ml_dropdown_list_selected">' + pStyleMap[lListEle]["text"] + '</p>').css(pStyleMap[lListEle]["css"]);
          _lWidgetDiv.append([_lSelected, _ldropDownIcon]);
          lHide();
          pOnValue(lListEle);
        });
      _lWidgetContent.append(_listElement);
    });

    const lShow = function () {
      _lWidgetContent.addClass('ml_dropdown_list_visible');
      _lWidgetDiv.addClass('ml_dropdown_active');
      _ldropDownIcon.removeClass(icons.chevronDown);
      _ldropDownIcon.addClass(icons.chevronUp);
      lIsVisible = true;
    };
    const lHide = function () {
      _lWidgetContent.removeClass('ml_dropdown_list_visible');
      _lWidgetDiv.removeClass('ml_dropdown_active');
      _ldropDownIcon.removeClass(icons.chevronUp);
      _ldropDownIcon.addClass(icons.chevronDown);
      lIsVisible = false;
    };
    const lToggle = function() {
      lIsVisible ? lHide() : lShow();
    };

    _lDiv.append([_lWidgetDiv, _lWidgetContent]);
    return _lDiv;
  }

  function dropdownTextIconButton(pID, pText, pBreakline, pIconClass, pTooltip, pOptions) {
    const lMenu = $('<div>').addClass('ml_dropdown_button_menu');
    let lIsShown = false;
    const lHide = function(pEvent) {
      pEvent && pEvent.stopPropagation();
      lMenu.removeClass('ml_dropdown_button_menu_visible');
      lButton.css('border-radius', '3px 3px 3px 3px');
      lIsShown = false;
      window.removeEventListener('click', lHide);
    };
    const lShow = function() {
      // Note (mkosarek): If we add this event listener immediately,
      // the lHide method above will be executed immediately, and our
      // dropdown will never open. We could just call 'stopPropagation'
      // on the current event to stop this, but then it will become
      // possible that we can open two dropdowns at the same time, because
      // clicking on the second dropdown will stop propagation, thus
      // preventing the 'lHide' on the first dropdown from executing.
      setTimeout(function() {
        window.addEventListener('click', lHide);
      }, 0);
      lMenu.addClass('ml_dropdown_button_menu_visible');
      lButton.css('border-radius', '0px 0px 3px 3px');
      lIsShown = true;
    };
    const lToggle = function(pEvent) {
      lIsShown ? lHide(pEvent) : lShow();
    };
    const lButton = textIconButton(pID, pText, pBreakline, pIconClass, pTooltip, lToggle)
      .css('position', 'relative').append(lMenu);

    pOptions.forEach(function(pOption) {
      let lOptionElement;
      if (typeof pOption.element === 'string') {
        lOptionElement = $('<div>').text(pOption.element);
      } else {
        lOptionElement = pOption.element;
      }

      lOptionElement.on('click', function(pEvent) {
        pEvent.stopPropagation();
        pOption.onClick();
      });

      lMenu.append(lOptionElement);
    });

    lButton.setDisabled = function(pIsDisabled) {
      lButton.attr('disabled', pIsDisabled);
      lHide();
    };

    return lButton;
  }

  function dropdownGroupedTextIconButton(id, text, iconClass, tooltip, optionsByGroup) {
    const lMenu = $('<div>').addClass('ml_dropdown_button_menu');
    let lIsShown = false;
    const lHide = function(pEvent) {
      pEvent && pEvent.stopPropagation();
      lMenu.removeClass('ml_dropdown_button_menu_visible');
      lButton.css('border-radius', '3px 3px 3px 3px');
      lIsShown = false;
      window.removeEventListener('click', lHide);
    };
    const lShow = function() {
      // Note (mkosarek): If we add this event listener immediately,
      // the lHide method above will be executed immediately, and our
      // dropdown will never open. We could just call 'stopPropagation'
      // on the current event to stop this, but then it will become
      // possible that we can open two dropdowns at the same time, because
      // clicking on the second dropdown will stop propagation, thus
      // preventing the 'lHide' on the first dropdown from executing.
      setTimeout(function() {
        window.addEventListener('click', lHide);
      }, 0);
      lMenu.addClass('ml_dropdown_button_menu_visible');
      lButton.css('border-radius', '0px 0px 3px 3px');
      lIsShown = true;
    };
    const lToggle = function(pEvent) {
      lIsShown ? lHide(pEvent) : lShow();
    };
    const lButton = textIconButton(id, text, true, iconClass, tooltip, lToggle)
      .css('position', 'relative').append(lMenu);

    const groupKeys = Object.keys(optionsByGroup);
    groupKeys.forEach(function(group, i) {
      lMenu.append(`<div class="ml_dropdown_menu_group_label">${group}</div>`);

      const options = optionsByGroup[group];
      options.forEach(function(option) {
        const optionElement = typeof option.element === "string" ? $("<div>").text(option.element) : option.element;

        optionElement.on('click', function(pEvent) {
          pEvent.stopPropagation();
          option.onClick();
        });

        lMenu.append(optionElement);
      });

      if (i + 1 < groupKeys.length) {
        lMenu.append(`<div class="ml_dropdown_menu_separator_line"></div>`);
      }
    });

    lButton.setDisabled = function(pIsDisabled) {
      lButton.attr('disabled', pIsDisabled);
      lHide();
    };

    return lButton;
  }

  function buttonIcon(pID, pText, pIconClass, pTooltip, pOnClick) {
    const lButton = $('<button class="ml_button_text_icon_simple" title="' + pTooltip + '"> </button>');
    const lIcon = $('<i class="' + pIconClass + '"></i>').css({ 'font-size': '1.3rem' });
    const lText = $('<span class="ml_button_text_decorated">' + pText + '</span>');

    pID && lButton.attr('id', pID);
    pOnClick && lButton.click(pOnClick);
    lButton.append(lIcon, lText);
    return lButton;
  }

  function checkButton(pID, pChecked, pIcon, pTooltip, pOnCheck) {
    const _lCheckButton = button(pID, pIcon, pTooltip);
    let _lChecked = pChecked;

    function _setStyle() {
      if(_lChecked) {
        _lCheckButton.addClass('checked');
      } else {
        _lCheckButton.removeClass('checked');
      }
    }

    _lCheckButton.on('set_checked', function(pEvent, pChecked) {
      _lChecked = pChecked;
      _setStyle();
    });

    _setStyle();
    _lCheckButton.click(function(pEvent) {
      _lCheckButton.trigger('set_checked', !_lChecked);
      if(pOnCheck) { pOnCheck(pEvent, _lChecked);}
    });

    return _lCheckButton;
  }

  function filePickerButton(pID, pIcon, pTooltip, pAccepts, pMultiple, pOnFiles, pTextAndIcon) {
    const _lButton = pTextAndIcon ? textIconButton(pID, pTextAndIcon.text, pTextAndIcon.breakline, pIcon, pTooltip) : button(pID, pIcon, pTooltip);
    const _lFileInput = $('<input type="file">');

    if(pAccepts) {
      _lFileInput.attr('accept', pAccepts);
    }
    if(pMultiple) {
      _lFileInput.attr('multiple', true);
    }
    _lButton.append(_lFileInput);

    _lButton.click(function() {
      _lFileInput.click();
    });
    _lFileInput.click(function(pEvent) {
      pEvent.stopPropagation(); // Prevents input click to bubble up to button click which creates a loop
    });
    _lFileInput.change(function(pEvent) {
      if(pOnFiles) {
        pOnFiles(pEvent.target.files);
      }
    });

    return _lButton;
  }

  function autoResizeTextInput(pValue) {
    const _lDiv = $('<div class="ml_autoresize_input">');
    const _lInput = $('<input type="text" class="truncated_text"/>').val(pValue);
    const _lHidden = $('<span class="truncated_text"/>').text(pValue);
    const _autoResize = function() {
      _lHidden.text(_lInput.val());
    };

    _lInput.on('input', _autoResize);
    _lDiv.on('autoresize', _autoResize);

    _lDiv.append(_lInput);
    _lDiv.append(_lHidden);

    _lDiv.getInput = function() { return _lInput; };

    _lDiv.enable = function() {
      _lInput.attr('disabled', false);
      return _lDiv;
    };

    _lDiv.disable = function() {
      _lInput.attr('disabled', true);
      return _lDiv;
    };

    _lDiv.setValue = function(pValue) {
      _lInput.val(pValue);
      _autoResize();
    };

    _lDiv.getValue = function() {
      return _lInput.val();
    };

    return _lDiv;
  }

  function treeView(pElement, pExpanded, pIsCollapsible, pIndentationLines) {
    const _lWrapper = $('<div>').addClass('ml_tree_view');
    const _lContentWrapper = $('<div>').appendTo(_lWrapper).addClass('h_layout').attr('id', 'tree-content-wrapper').css('align-items', 'center');
    const _lCaret = pIsCollapsible ? $('<i>').addClass('fa fa-caret-right').appendTo(_lContentWrapper).on('click', function() {
      if (!pIsCollapsible) {
        return;
      }

      if (_lChildren.css('display') === 'none') {
        _lWrapper.expand();
      } else {
        _lWrapper.collapse();
      }
    }) : undefined;
    const _lElementWrapper = $('<span>').append(pElement).appendTo(_lContentWrapper).on('click', function() {
      // Note (mkosarek), Whenever we click on a tree view item, we always expand it
      if (_lChildren.css('display') === 'none') {
        _lWrapper.expand();
      }
    });
    const _lChildren = $('<ul>').appendTo(_lWrapper);
    const _lUpdateCaret = function() {
      if (_lCaret === undefined) {
        return;
      }

      if (_lWrapper.shouldDisplayCaret && _lWrapper.shouldDisplayCaret()) {
        _lCaret.css('color', 'initial');
        return;
      }

      if (_lChildren.children().length === 0) {
        _lCaret.css('color', 'transparent');
      } else {
        _lCaret.css('color', 'initial');
      }
    };

    if (!pIsCollapsible) {
      pExpanded = true;
    }

    _lWrapper.addChild = function(pId, pChild, pIndex, pShouldShowIndentLines) {
      const _lHorizontalLine = $('<span>').addClass('ml_tree_view_horizontal_indent_line');
      const _lVerticalLine = $('<span>').addClass('ml_tree_view_vertical_indent_line');
      const _lChild = $('<li' + (pId ? ' id="' + pId + '"' : '') + '/>').append(_lHorizontalLine).append(_lVerticalLine);

      if(typeof pChild == "string") {
        // Simple string
        _lChild.addClass('truncated_text');
        _lChild.text(pChild);
      } else {
        // Nested element
        _lChild.append(pChild);
      }

      if (pShouldShowIndentLines || pIndentationLines && _lChild.find('.ml_tree_view').length === 0) {
        // We never add the indentation lines to point to a nested tree
        _lChild.addClass('ml_with_indent_line');
      }

      if(undefined == pIndex || pIndex >= _lChildren.children().length) {
        _lChildren.append(_lChild);
      } else {
        $(_lChildren.children().get(pIndex)).before(_lChild).last();
      }

      _lUpdateCaret();
      return _lChild;
    };

    _lWrapper.removeChild = function(pIndex) {
      _lChildren.children().eq(pIndex).remove();
      _lUpdateCaret();
    };

    _lWrapper.removeAllChild = function() {
      _lChildren.children().remove();
      _lUpdateCaret();
    };

    _lWrapper.moveChild = function(pFrom, pTo) {
      if (pTo < pFrom) {
        _lChildren.children().eq(pFrom).insertBefore(_lChildren.children().eq(pTo));
      } else {
        _lChildren.children().eq(pFrom).insertAfter(_lChildren.children().eq(pTo));
      }
    };

    _lWrapper.expand = function() {
      pExpanded = true;
      if (_lCaret) {
        _lCaret.removeClass('fa-caret-right').addClass('fa-caret-down');
      }
      _lChildren.css('display', 'block');

      if (_lWrapper.onExpand) {
        _lWrapper.onExpand();
      }
    };

    _lWrapper.collapse = function() {
      pExpanded = false;
      if (_lCaret) {
        _lCaret.removeClass('fa-caret-down').addClass('fa-caret-right');
      }
      _lChildren.css('display', 'none');
      if (_lWrapper.onCollapse) {
        _lWrapper.onCollapse();
      }
    };

    _lWrapper.getContent = function() {
      return _lElementWrapper;
    };

    if (pExpanded) {
      _lWrapper.expand();
    }

    _lWrapper.isExpanded = function() {
      return pExpanded;
    };

    _lUpdateCaret();

    _lWrapper.updateCaret = _lUpdateCaret;

    return _lWrapper;
  }

  function divider(pStyle) {
    const divider = $('<hr class="ml-widget-divider" />');
    pStyle && divider.css(pStyle);
    return divider;
  }

  /**
   * @deprecated
   *
   * This function is no longer used in MachineLogic other than in `robotApplicationDocument`
   *
   * @param {number} getTabIndex
   * @param {Object} bodyStyle
   * @returns {JQuery}
   */
  function tab(getTabIndex, bodyStyle) {
    const container = $('<div>  </div>').css({ width: '100%' });
    const tabs = $('<ul class="ml_tab_header"> </ul>');
    const body = $('<div class="ml_tab_body"> </div>').css(bodyStyle);
    const pages = {};
    let activePage = '';

    function activatePage(pPageName, onPageChange) {
      if (activePage) {
        activePage.hide();
        activePage.onUnmount?.();
      }

      if (pages[pPageName]) {
        activePage = pages[pPageName];
        activePage.onMount?.();
        activePage.show();
        onPageChange?.();
      }
    }

    function addTab(pTabObject, onPageChange) {
      const listItem = $('<li>');
      listItem.append($('<span>', { text: pTabObject.title }));

      if (pTabObject.icon) {
        listItem.append(pTabObject.icon);
      }

      listItem.click(function () {
        tabs.children().removeClass('ml_tab_selected');
        listItem.addClass('ml_tab_selected');
        activatePage(pTabObject.title, onPageChange);
        getTabIndex && getTabIndex(tabs.children().index(listItem));
      });

      pages[pTabObject.title] = pTabObject.page;
      pTabObject.page.hide();
      tabs.append(listItem);
      body.append(pTabObject.page);

      // select the first tab by default
      if (1 === tabs.children().length && !getTabIndex) {
        $(tabs.children()[0]).trigger('click');
      }
    }

    const lDivider = divider({ left: 0, width: 'calc(100% - 2px)', 'margin-block-start': 'unset', 'margin-block-end': '1rem', 'margin': '0 0 0.5rem 0' });
    container.append(tabs, lDivider,body);
    container.addTab = addTab;
    return container;
  }


  /**
   *
   * @param {string} title
   * @param {JQuery} page
   * @param {JQuery} icon
   */
  function tabLink(title, page, icon) {
    return {
      title: title,
      page: page,
      icon: icon
    };
  }

  function select(pTooltip) {
    const lDiv = $('<div class="ml_select_widget"> </div>');
    const lSelect = $('<select title="' + pTooltip + '"> </select>');

    lDiv.getSelect = function() {
      return lSelect;
    };
    lDiv.append(lSelect);
    return lDiv;
  }

  /// @param {function} pOnClick take an Event as parameter
  function inlineButtonWithText(pIcon, pText, pOnClick) {
    const _lButton = $('<button class="h_layout ml_button_bordered"> </button>').css({ 'align-items': 'center', display: 'flex' });
    const _lIcon = $('<i class="' + pIcon + ' ml_button_bordered_icon"></i>');
    const _lText = $('<h4 class="ml_button_bordered_text">' + pText + '</h4>');
    const _updateIcon = function (_pIcon) {
      _lIcon.removeClass();
      _lIcon.addClass(_pIcon);
    };

    if (pOnClick) {
      _lButton.on('click', pOnClick);
    }

    _lButton.append(_lIcon, _lText);

    _lButton.updateIcon = _updateIcon;
    return _lButton;
  }

  /**
  * Display equivalent unit when handle different type of actuators
  * @param {String} pBefore - Symbol to show before the value
  * @param {String} pValue - value
  * @param {String} pAfter - what to show after the actual number
  * @returns returns a div styled "prefix" + value + "suffix"
  */
  function innerUnitDisplay(pBefore, pValue, pAfter) {
    return $('<div class="ml_additional_display">' + pBefore + '<span>' + pValue + '</span>' + pAfter + '</div>');
  }

  /**
   *
   * @param {string} [pName]
   * @param {Array} pList
   * @param {string} pTooltip
   * @param {string} pValue
   * @param {function} pOnValue A function receiving aas parameter the value selected.
   *                   It will be a Number if all the elements pList[X].text are Numbers
   * @param {function} pOnDrop
   * @param {function} pLabelTransformFunction
   * @param {Object} [options]
   * @param {string} [options.tooltipKey] key to use to get the tooltip text
   * @returns
   */
  function listWidget(pName, pList, pTooltip, pValue, pOnValue, pOnDrop, pLabelTransformFunction, { tooltipKey = undefined } = {}) {
    const _lDiv = pName ? baseWidget(pName, pLabelTransformFunction, {tooltipKey}) : null;
    const _lWidgetDiv = select(pTooltip);
    const _lWidget = _lWidgetDiv.getSelect();
    const _lIsNumeric = pList.length > 0 && pList.reduce(function (pValue, pItem) { return pValue && (typeof pItem == 'number'); }, true);
    const handleOptions = function(pV) {
      if (pV === null) { _lWidget.append($('<option value="' + pV + '">' + 'None' + '</option>')); return; }
      if (typeof pV == 'string') {
        if(/hardware version/ig.test(pName)) {
          _lWidget.append($('<option value="' + pV + '">' + handleHardwareVersion(pV) + '</option>'));
        } else {
          _lWidget.append($('<option value="' + pV + '">' + camelCaseToText(pV) + '</option>'));
        }
      } else if (typeof pV == 'number') {
        // See ticket #86
        let lPrefix;
        // TODO: it should be done outside of the component
        if (/(control device|digital io)/ig.test(pName)) { lPrefix = 'Digital IO '; }
        else if (/(valve|push|pull)/ig.test(pName)) { lPrefix = 'Out '; }
        else if (/(position)/ig.test(pName)) { lPrefix = 'In '; }
        else { lPrefix = ''; }
        // See ticket #vention-control/533
        const lSuffix = /Micro Steps/ig.test(pName) && /8/ig.test(pV) ? ' (default)' : '';
        _lWidget.append($('<option value="' + pV + '">' + lPrefix + pV + lSuffix + '</option>'));
      } else {
        if (pV.deprecated) {
          if (pV.value == pValue) { _lWidget.append($('<option value="' + pV.value + '" disabled>' + pV.text + '</option>')); }
        } else {
          _lWidget.append($('<option value="' + pV.value + '">' + pV.text + '</option>'));
        }
      }
    };

    // Listening to drop only the list widget that deal with sensor;
    // #2192
    if (/sensor/ig.test(pName)) {
      _lWidget.on('dragover', function (_e) { _e.preventDefault(); });
      _lWidget.on('dragenter', function (_e) { _e.target.style.background = '#777777'; });
      _lWidget.on('dragleave', function (_e) { _e.target.style.background = ''; });
      pOnDrop && _lWidget.on('drop', pOnDrop);
    }

    updateOptions(pList);

    function handleHardwareVersion(pHarwareVersion) {
      if(/-1D$/i.test(pHarwareVersion)){
        return `${pHarwareVersion.split("-")[0]} ONE-DRIVE`;
      } else {
        return `${pHarwareVersion.split("-")[0]} FOUR-DRIVE`;
      }
    }

    function hasDeprecatedInstruction(list, value) {
      if (typeof list[0] == 'string' || typeof list[0] == 'number') {
        return !list.includes(value);
      }
      // [{ value: "moveRelative", text: "moveRelative"}, {{ value: "moveAbsolute", text: "moveAbsolute"}}]
      const flatValueList = list.map(function (obj) { return obj && obj.value; });
      return !flatValueList.includes(value);
    }

    if (hasDeprecatedInstruction(pList, pValue)) {
      // Display deprecated motion instructions
      if (typeof pValue == 'string' && pName == "motion") {
        _lWidget.append($('<option value="' + pValue + '" disabled>' + camelCaseToText(pValue) + '</option>'));
      }
    }

    _lWidget.change(function (pEvent) {
      pEvent.stopPropagation();
      if (pOnValue) {
        pOnValue(_lIsNumeric ? parseInt(_lWidget.val()) : _lWidget.val());
      }
    });

    if (pValue instanceof Array) {
      _lWidget.attr('multiple', true);
    }

    function _getValue() {
      return _lWidget.val();
    }

    function _setValue(pValue) {
      _lWidget.val(pValue);
    }
    _setValue(pValue);

    function updateOptions(optionsList) {
      // Remove children and reinsert with the new list
      _lWidget.children().remove();
      optionsList.forEach(handleOptions);
    }

    function updateLabel(pLabel) {
      if (!_lDiv) { return; }
      _lDiv.find('h5').html(camelCaseToText(pLabel));
    }

    /**
     *
     * @param {jQuery} pIcon - A jQuery icon representing an icon
     */
    function setLabelIcon(pIcon) {
      if (!_lDiv) { return; }
      pIcon.addClass('ml_label_icon');
      const _lExistingIcon = _lDiv.find('.ml_label_icon');
      if (_lExistingIcon.length) {
        _lExistingIcon.replaceWith(pIcon);
      } else {
        _lDiv.find('.h_layout').append(pIcon);
      }
    }

    function detachLabelIcon() {
      if (!_lDiv) { return; }
      const _lExistingIcon = _lDiv.find('.ml_label_icon');
      if (_lExistingIcon.length) {
        _lExistingIcon.detach();
      }
    }

    if (_lDiv) {
      _lDiv.append(_lWidgetDiv);
      _lDiv.addClass('v_layout spaced');
      _lDiv.getValue = _getValue;
      _lDiv.setValue = _setValue;
      _lDiv.getSelect = _lWidgetDiv.getSelect;
      _lDiv.updateLabel = updateLabel;
      _lDiv.updateOptions = updateOptions;
      _lDiv.setLabelIcon = setLabelIcon;
      _lDiv.detachLabelIcon = detachLabelIcon;
      return _lDiv;
    } else {
      _lWidgetDiv.getValue = _getValue;
      _lWidgetDiv.setValue = _setValue;
      _lWidgetDiv.updateOptions = updateOptions;
      return _lWidgetDiv;
    }
  }

  /**
  *
  * @param {string} pName - Used as id
  * @param {string} pTooltip - Should as tooltip when hovered
  * @param {number} pValue
  * @param {string} pUnits - Unit to represent the value
  * @param {{ min: number, max: number, step: number, info: string }} pOptions - Options are used to set the limits, step, and show some information
  * @param {function} pOnValue - value triggered when change value
  */
  function numberWidget(pName, pTooltip, pValue, pUnits, pOptions, pOnValue, pAllowEmpty) {
    const _lDiv = pName ? baseWidget(pName, pOptions && pOptions.labelTransformFunction) : null;
    const _lWidget = $('<input type="number" title="' + pTooltip + '"/>');
    let _lInfo = (pOptions && pOptions.info) ? $('<span class="ml_input_info">').text(pOptions.info) : undefined;
    const _lError = $('<span class="ml_input_validation_error"> </span>');
    let _lDivAdditionalDisplay;
    let _lUnits;
    let _lConfig;
    const lConfigListenerMapping = {};

    if (pUnits) {
      // Dynamic units
      if (pUnits.includes("configDependant")) {
        const _determineConfigDependantUnit = function () {
          let _lUnit = pOptions.configManager._getConfigDependant_Unit();
          if (pUnits.includes("Velocity")) {
            _lUnit = _lUnit + "/s";
          }
          else if (pUnits.includes("Acceleration")) {
            _lUnit = _lUnit + "/s^2";
          }
          return _lUnit;
        };
        _lWidget.css('width', 'calc(100% - 35px)');
        _lUnits = $('<div class="ml_parameter_unit">' + _determineConfigDependantUnit().replace(/\^([0-9]+)/g, '<sup>$1</sup>') + '</div>');
        // React to config changes
        const _updateConfigDependantUnit = function () {
          _lDiv.find('.ml_parameter_unit').html(_determineConfigDependantUnit().replace(/\^([0-9]+)/g, '<sup>$1</sup>'));
        };

        pOptions.configManager.getConfigurationList().forEach(function(pConfig) {
          const lConfigListener = {
            onAxisAdded: function () {
              _updateConfigDependantUnit(),
              pOptions.needAdditionalDisplay && _updateVisibility();
            },
            onAxisRemoved: function () {
              _updateConfigDependantUnit();
              pOptions.needAdditionalDisplay && _updateVisibility();
            },
            onAxisTypeChanged: function () {
              _updateConfigDependantUnit();
              pOptions.needAdditionalDisplay && _updateVisibility();
            }
          };

          pConfig.addListener(lConfigListener);
          lConfigListenerMapping[pConfig.getController().getUUID()] = lConfigListener;
        });
      }
      // Static units
      else {
        (pUnits == "mm" || pUnits == "deg") ? _lWidget.css('width', 'calc(100% - 35px)') : _lWidget.css('width', 'calc(100% - 57.5px)');
        _lUnits = $('<div class="ml_parameter_unit">' + pUnits.replace(/\^([0-9]+)/g, '<sup>$1</sup>') + '</div>');
      }
    }
    _lWidget.val(pValue);
    if (pOptions) {
      Object.keys(pOptions).forEach(function (pOption) {
        _lWidget.attr(pOptions, pOptions[pOption]);
      });
    }
    _lWidget.change(function (pEvent) {
      pEvent.stopPropagation();

      // Check bounds
      if (pAllowEmpty && _lWidget.val() == ''){
        pOnValue(null);
        return;
      }
      if (isNaN(parseInt(_lWidget.val()))) { _lWidget.val(0); }
      if (undefined != pOptions.min && _lWidget.val() <= pOptions.min) { _lWidget.val(pOptions.min); }
      if (undefined != pOptions.max && _lWidget.val() > pOptions.max) { _lWidget.val(pOptions.max); }

      if (pOnValue) {
        pOnValue(_lWidget.val());
      }
    });

    _lWidget.on('input', helpers.debounce((function (pEvent) {
      pEvent.stopPropagation();
      // Check bounds

      if (undefined != pOptions.min && _lWidget.val() < pOptions.min) {
        _lError.show();
        _lError.text('Value must be greater than ' + pOptions.min).show();
      } else if (undefined != pOptions.max && _lWidget.val() > pOptions.max) {
        _lError.show();
        _lError.text('Value must be smaller than ' + pOptions.max).show();
      } else {
        _lError.hide();
        if (!isNaN(parseInt(_lWidget.val()))) {
          if (pOnValue) {
            pOnValue(_lWidget.val());
            if (pOptions.needAdditionalDisplay) {
              _lDivAdditionalDisplay.find('span').text(_lWidget.val());
            }
          }
        }
      }
    }), 400));

    function setValue(lValue) {
      _lWidget.val(lValue);
      if (pOptions.needAdditionalDisplay) {
        _lDivAdditionalDisplay.find('span').text(lValue);
      }
    }
    // handle visibility to additional unit display
    function _updateVisibility() {
      if (_lConfig) {
        const _lMmPresence = _lConfig._getConfigDependant_DegAndMMPresence()._lMmPresence;
        const _lDegPresence = _lConfig._getConfigDependant_DegAndMMPresence()._lDegPresence;
        _lDegPresence && _lMmPresence ? _lDivAdditionalDisplay.show() : _lDivAdditionalDisplay.hide();
      }
    }

    function setOptions(pNewOptions) {
      if (pOptions) {
        pOptions = Object.assign({}, pOptions, pNewOptions);
      } else {
        pOptions = pNewOptions;
      }

      if (_lInfo) {
        _lInfo.remove();
      }
      if (pOptions.info) {

        _lInfo = $('<span class="ml_input_info">').text(pOptions.info);
        if (_lDiv) {
          _lDiv.append(_lInfo);
        }
      }
    }

    if (pOptions.needAdditionalDisplay) {
      _lConfig = pOptions.configManager;
      _lDivAdditionalDisplay = innerUnitDisplay(pOptions.additionalDisplay.before, pValue, pOptions.additionalDisplay.after)
        .css({ 'align-self': 'flex-end', 'font-size': '0.9rem', 'line-height': '1rem', padding: '0 0.25rem' });
      _lDivAdditionalDisplay.find('span').css({ padding: '0 0.25rem' });
      // Determine if the parameter of type configDependant needs an additional display or not
      _updateVisibility();
    }

    function onRemoveCallback() {
      if (pUnits && pUnits.includes("configDependant")) {
        Object.keys(lConfigListenerMapping).forEach(function(pControllerId) {
          const lConfig = pOptions.configManager.getConfiguration(pControllerId);
          if (lConfig) {
            lConfig.removeListener(lConfigListenerMapping[pControllerId]);
          }
        });
      }
    }

    if (_lDiv) {
      _lDiv.append($('<div class="ml_parameter_widget h_layout spaced"/>').append(_lWidget).append(_lUnits).append());
      pOptions.needAdditionalDisplay && _lDiv.append(_lDivAdditionalDisplay);
      _lDiv.append(_lError);
      if (_lInfo != undefined) {
        _lDiv.append(_lInfo);
      }
      _lDiv.setValue = setValue;
      _lDiv.setOptions = setOptions;
      _lDiv.addClass('v_layout spaced');

      _lDiv.on('remove', onRemoveCallback);

      return _lDiv;
    } else {
      _lWidget.addClass('ml_parameter_widget');
      _lWidget.addClass('v_layout spaced');
      _lWidget.setValue = setValue;
      _lWidget.setOptions = setOptions;

      _lWidget.on('remove', onRemoveCallback);

      return _lWidget;
    }
  }

  /**
   *
   * @param {String} pName
   * @param {String} pTooltip
   * @param {String} pValue
   * @param {function(String) => void} pOnValue
   * @param {function(String) => String} pFunctionsValidation
   * @param {Object} [pOptions]
   * @param {boolean} [pOptions.allowEmpty]
   * @param {function(String) => String} [pOptions.labelTransformFunction]
   * @param {String} [pOptions.tooltipKey] key to use to get the tooltip text
   * @returns
   */
  function stringWidget(pName, pTooltip, pValue, pOnValue, pFunctionsValidation, pOptions = {}) {
    const lAllowEmpty = pOptions.allowEmpty;
    const lLabelTransformFunction =  pOptions.labelTransformFunction;
    const tooltipKey = pOptions.tooltipKey;
    const _lDiv = pName ? baseWidget(pName, lLabelTransformFunction, {tooltipKey}) : null;
    const _lWidget = $('<input autocomplete="do-not-autofill" type="text" class="ml_parameter_widget truncated_text" title="' + pTooltip + '">'); // [oliver levy]: "do-not-autofill" so that chrome will not think that we want to autofill the users personal information https://stackoverflow.com/questions/15738259/disabling-chrome-autofill
    const _lError = $('<span class="ml_input_validation_error"> </span>');
    let _lLastValue;
    const _lIsValidValue = pFunctionsValidation ? helpers.validateForm(pFunctionsValidation) : function () { return undefined; };
    // Please see ticket VentionCo/mm-vention-control#685
    // This is just to cache the value before the input change
    _lWidget.on("focusin",() => {
      _lLastValue = _lWidget.val().trim();
    });
    _lWidget.val(pValue);

    _lWidget.on("change", (pEvent) => {
      pEvent.stopPropagation();
      // Trimming because of ticket #vention_assembler/2069
      // This ticket had a side effect on the configuration of the axis name on MachineMotion vse
      const lValue = _lWidget.val().trim();

      const lRevertChanges = (pError) => {
        _lWidget.val(_lLastValue);
        _lError.hide();
      };

      const lSaveChanges = (pValue) => {
        _lLastValue = pValue;
        _lWidget.val(pValue);
        pOnValue && pOnValue(pValue);
        _lError.hide();
      };


      // If the value is empty and empty values are not allowed, revert to the last saved value else set the value to empty
      if (lValue === '') {
        lAllowEmpty ? lSaveChanges(lValue) : lRevertChanges('Empty values are not allowed');
        return;
      }

      // If the value is not valid, revert to the last saved value else set the value to the new value
      const lValidationResult = _lIsValidValue(lValue);
      lValidationResult !== undefined ? lRevertChanges(lValidationResult) : lSaveChanges(lValue);
    });

    _lWidget.on('input', helpers.debounce(function (pEvent) {
      pEvent.stopPropagation();
      const lValue = _lWidget.val().trim();
      // to skip validating against it's previous valid value which triggers unintentional validation errors when user manually reverts changes (i.e isNameUsed)
      const lValidationError = lValue !== _lLastValue ? _lIsValidValue(lValue) : undefined;
      lValidationError ? _lError.text(lValidationError).show() : _lError.hide();

    }, 300));

    if (_lDiv ){
      _lDiv.append(_lWidget);
      _lDiv.append(_lError);
      _lDiv.addClass('v_layout spaced');
      return _lDiv;
    } else {
      _lWidget.addClass('v_layout spaced');
      return _lWidget;
    }
  }

  /**
   *
   * @param {String} pParentDivID
   * @param {String} pContent
   * @returns
   */

  function aceEditor(pParentDivID, pContent) {
    const _lEditor = ace.edit(pParentDivID, {
      mode: "ace/mode/javascript",
      theme: "ace/theme/cloud9_day",
      tabSize: 2,
      wrap: true
    });

    _lEditor.setOptions({
      useWorker: false
    });

    if (pContent) {
      _lEditor.setValue(pContent,1);
    } else {
      _lEditor.setValue(JSON.stringify(pContent, null, 2));
    }
    return _lEditor;
  }

  /**
   *
   * @param {String} pName
   * @param {String} pTooltip
   * @param {String} pValue
   * @param {function(String) => void} pOnValue
   * @param {Object} pOptions
   * @returns
   */

  function aceEditorWidget(pName, pTooltip, pValue, pOnValue, pFunctionsValidation, pOptions, pUniqueID) {
    const lAllowEmpty = pOptions && pOptions.allowEmpty;
    const lLabelTransformFunction = pOptions && pOptions.labelTransformFunction;
    const _lDiv = pName ? baseWidget(pName, lLabelTransformFunction).css('grid-column', '1 / -1') : null;
    const _lWidget = $('<div id="aceWidget_' + pUniqueID + '" style="height:2.5rem;" class="ml_parameter_widget_ace ace_widget" title="' + pTooltip + '">');
    const _lError = $('<span class="ml_input_validation_error"> </span>');
    let _lLastValue;
    const _lIsValidValue = pFunctionsValidation ? helpers.validateForm(pFunctionsValidation) : function () { return undefined; };
    const _lCardChevron   = $('<div id="chevron_lambda' + pUniqueID + '" style="transform:rotateY(180deg); margin-top:3px;"" class="validation_chevron icon-chevron" >');

    // Please see ticket VentionCo/mm-vention-control#685
    // This is just to cache the value before the input change
    _lWidget.focusin(function () {
      _lLastValue = _lWidget.val().trim();
    });

    _lWidget.val(pValue);

    _lCardChevron.click(function() {
      _lWidget.toggleClass('selected');
      const _lEditor = ace.edit(`aceWidget_${pUniqueID}`);
      if (_lWidget.hasClass('selected')) {
        document.getElementById(`aceWidget_${pUniqueID}`).style.height = "200px";
        document.getElementById(`chevron_lambda${pUniqueID}`).style.transform = "rotateZ(180deg)";
        _lEditor.resize();
      } else {
        document.getElementById(`aceWidget_${pUniqueID}`).style.height = "2.5rem";
        document.getElementById(`chevron_lambda${pUniqueID}`).style.transform = "rotateY(180deg)";
        _lEditor.resize();
      }
    });

    _lWidget.change(function (pEvent) {
      pEvent.stopPropagation();
      // Trimming because of ticket #vention_assembler/2069
      // This ticket had a side effect on the configuration of the axis name on MachineMotion vse
      const _lEditor = ace.edit(`aceWidget_${pUniqueID}`);
      const lValue = _lEditor.getValue();
      // Please see ticket VentionCo/mm-vention-control#685
      lAllowEmpty ? _lWidget.val(lValue) : (lValue ? _lWidget.val(lValue) : _lWidget.val(_lLastValue));
      if (pOnValue) {
        const lValidationError = _lIsValidValue(lValue);
        if (lValidationError) {
          _lWidget.val(_lLastValue);
        }
        lAllowEmpty ? pOnValue(lValue, lValidationError) : (lValue ? pOnValue(lValue, lValidationError) : pOnValue(_lLastValue, lValidationError));
      }
      _lError.hide();
    });

    function onRemoveCallback (){
      $(document).off('click');
    }

    $(document).click( helpers.debounce(function (pEvent) {
      _lWidget.trigger('change');
      pEvent.stopPropagation();
      const _lEditor = ace.edit(`aceWidget_${pUniqueID}`);
      const lValue = _lEditor.getValue();
      const lValidationError = _lIsValidValue(lValue);
      lValidationError ? _lError.text(lValidationError).show() : _lError.hide();
    }, 300));

    _lWidget.on('input', helpers.debounce(function (pEvent) {
      _lWidget.trigger('change');
      pEvent.stopPropagation();
      const _lEditor = ace.edit(`aceWidget_${pUniqueID}`);
      const lValue = _lEditor.getValue();
      const lValidationError = _lIsValidValue(lValue);
      lValidationError ? _lError.text(lValidationError).show() : _lError.hide();
    }, 300));

    _lWidget.on('document_opened', function(){
      aceEditor( `aceWidget_${pUniqueID}`, _lWidget.val().trim());
    });

    if (_lDiv) {
      _lDiv.append(_lWidget);
      _lDiv.append(_lError);
      _lDiv.addClass('v_layout spaced');
      _lDiv.append(_lCardChevron);
      _lDiv.on('remove', onRemoveCallback);
      return _lDiv;
    } else {
      _lWidget.addClass('v_layout spaced');
      _lDiv.append(_lCardChevron);
      _lWidget.on('remove', onRemoveCallback);
      return _lWidget;
    }
  }

  /**
   *
   * @param {String} pName
   * @param {String} pTooltip
   * @param {String} pValue
   * @param {function(String) => void} pOnValue
   * @param {Object} pOptions
   * @returns
   */

  function applicationPackParameterWidget(pApplication, pParameter, pSequence, pInstruction, pInstructionParameter) {
    const lParameterObj = pApplication.getParametersObject();
    // Validation functions
    const required = function (value) { return value ? undefined : 'This field is required';};
    const isNameUsed = function (value) { return !lParameterObj.isNameUsed(value) ? undefined : 'Variable name is already used'; };
    const isValidVariableName = function (value) { return lParameterObj.isValidVariableName(value) ? undefined : 'Invalid name : avoid blank spaces, special characters and reserved keywords'; };
    const lParameterName = this.stringWidget('Unpack Variable Name', 'Name for variables', pParameter.name, function(pValue) {
      pApplication.updateApplicationParameter(pParameter.id, { name: pValue });
      pInstruction.setParameter(pInstructionParameter, pParameter.name);
    }, [required, isNameUsed, isValidVariableName]);

    return lParameterName;
  }


  /* Module export glue */
  /* global define */
  const gExports = {
    aceEditor: aceEditor,
    aceEditorWidget: aceEditorWidget,
    autocompleteWidget: autocompleteWidget,
    autoResizeTextInput: autoResizeTextInput,
    baseWidget: baseWidget,
    buttonIcon: buttonIcon,
    camelCaseToText: camelCaseToText,
    showConfirmationModal: showConfirmationModal,
    showConfirmCancelModal: showConfirmCancelModal,
    card: card,
    checkbox: checkbox,
    checkBoxParameter: checkBoxParameter,
    checkButton: checkButton,
    clearMessageBox: clearMessageBox,
    contextMenu: contextMenu,
    divider: divider,
    downloadJson: downloadJson,
    dropdownTextIconButton: dropdownTextIconButton,
    dropdownGroupedTextIconButton,
    dropDownWidget: dropDownWidget,
    filePickerButton: filePickerButton,
    idGenerator: gIdGenerator,
    inlineButtonWithText: inlineButtonWithText,
    listWidget: listWidget,
    loadingModal,
    messageBox: messageBox,
    numberWidget: numberWidget,
    pneumaticCommands: pneumaticCommands,
    pushButton: pushButton,
    tab: tab,
    tabLink: tabLink,
    select: select,
    stringWidget: stringWidget,
    textButton: textButton,
    textIconButton: textIconButton,
    applicationPackParameterWidget: applicationPackParameterWidget,
    treeView: treeView // Note: automation
  };
  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
